import React, { useState, useEffect } from "react";
import { useFetcher, useLocation } from "react-router-dom";

import { text } from "../text";
import { hooks } from "../hooks";
import { utils } from "../utils";
import { svg } from "../assets/svg";
import { theme } from "../constants";
import { components } from "../components";
import { colors } from "../constants/colors";
import { FilterSvg } from "../assets/svg/FilterSvg";

const price = [
    {
        id: 1,
        name: "Paid (142)",
    },
    {
        id: 2,
        name: "Free (18)",
    },
];

export const Onboarding7: React.FC = () => {
    const location = useLocation();

    const { pathname } = useLocation();
    const defaultPrice: [number, number] = [2000, 8000];
    const [priceRange, setPriceRange] = useState<[number, number]>([1000, 20000]); // default range
    const minLimit = 1000;
    const maxLimit = 50000;
    const minGap = 500;

    const selectedCity = sessionStorage.getItem("selectedCity");

    const [genderError, setGenderError] = useState<string>("");
    const [priceError, setPriceError] = useState<string>("");

    const [filter, setFilter] = useState<{
        selectedLocality: string[];
        gender: string;
        price: [number, number];
        RoomType: string;
    }>({
        selectedLocality: [],
        gender: "",
        price: [2000, 8000],
        RoomType: "PG",
    });

    useEffect(() => {
        const storedMin = sessionStorage.getItem("minAmount");
        const storedMax = sessionStorage.getItem("maxAmount");

        if (storedMin && storedMax) {
            const min = Number(storedMin);
            const max = Number(storedMax);
            if (!isNaN(min) && !isNaN(max) && min < max) {
                setPriceRange([min, max]);
            }
        }
    }, []);

    const rangeInputStyle: React.CSSProperties = {
        position: "absolute",
        top: 22,
        width: "100%",
        height: "4px",
        background: "transparent",
        pointerEvents: "auto",
        zIndex: 4,
    };

    useEffect(() => {
        const storedGender = sessionStorage.getItem("gender");
        if (storedGender) {
            setFilter((prev) => ({
                ...prev,
                gender: storedGender,
            }));
        }
    }, []);

    useEffect(() => {
        const scrollToTop = () => {
            window.scrollTo(0, 0);
            document.documentElement.scrollTop = 0;
        };

        scrollToTop();
    }, [pathname]);

    const navigate = hooks.useNavigate();

    const [selectedPrice, setSelectedPrice] = useState<number | null>(
        price[0].id
    );

    // handle locality here
    useEffect(() => {
        const selectedLocality = sessionStorage.getItem("selectedLocality");
        if (selectedLocality) {
            try {
                const parsedLocality = JSON.parse(selectedLocality);
                setFilter((prevFilter) => ({
                    ...prevFilter,
                    selectedLocality: parsedLocality,
                }));
            } catch (error) {
                console.error("Failed to parse selectedLocality:", error);
            }
        }
    }, []);

    // Gender
    const handleGender = (inputGender: string) => {
        setFilter((prevFilter) => {
            const updateFilter = {
                ...prevFilter,
                gender: inputGender,
            };
            // console.log(inputGender, "this is input Gender");
            setGenderError(""); // ✅ Clear error
            let genderKey = "";

            switch (inputGender.toLowerCase()) {
                case "male":
                    genderKey = "GENDER_MALE";
                    break;
                case "female":
                    genderKey = "GENDER_FEMALE";
                    break;
                case "other":
                    genderKey = "GENDER_OTHER";
                    break;
                default:
                    genderKey = "GENDER_UNSPECIFIED";
            }

            // Save mapped value to sessionStorage for API
            sessionStorage.setItem("genderAPI", genderKey);
            sessionStorage.setItem("gender", inputGender);
            return updateFilter;
        });
    };

    const handleRemoveCity = (cityToRemove: string) => {
        // Step 1: Update selectedLocality (names)
        const updatedLocality = filter.selectedLocality.filter(
            (item) => item !== cityToRemove
        );

        setFilter((prevFilter) => ({
            ...prevFilter,
            selectedLocality: updatedLocality,
        }));

        sessionStorage.setItem("selectedLocality", JSON.stringify(updatedLocality));

        // Step 2: Update SelectedLocalityId
        const fullListRaw = sessionStorage.getItem("selectedLocalityFull");
        const fullList = fullListRaw ? JSON.parse(fullListRaw) : [];

        // Find ID to remove
        const cityObj = fullList.find(
            (loc: { locality_name: string }) => loc.locality_name === cityToRemove
        );
        if (!cityObj) return;

        const cityIdToRemove = String(cityObj.locality_id);

        const existingIdsRaw = sessionStorage.getItem("SelectedLocalityId");
        const existingIds = existingIdsRaw
            ? existingIdsRaw.split(",").map((id) => id.trim())
            : [];

        const updatedIds = existingIds.filter((id) => id !== cityIdToRemove);
        sessionStorage.setItem("SelectedLocalityId", updatedIds.join(", "));

        // Step 3: Update selectedLocalityFull
        const updatedFullList = fullList.filter(
            (loc: { locality_name: string }) => loc.locality_name !== cityToRemove
        );
        sessionStorage.setItem(
            "selectedLocalityFull",
            JSON.stringify(updatedFullList)
        );
    };

    useEffect(() => {
        console.log("Updated filter:", filter);
    }, [filter]);

    const handleChangeCity = () => {
        // sessionStorage.clear();
        sessionStorage.removeItem("selectedLocality");
        sessionStorage.removeItem("selectedLocalityFull");
        sessionStorage.removeItem("SelectedLocalityId");
        navigate("/onbording5");
    };

    // Debounced effect
    useEffect(() => {
        const handler = setTimeout(() => {
            setFilter((prev) => {
                if (
                    prev.price[0] !== priceRange[0] ||
                    prev.price[1] !== priceRange[1]
                ) {
                    return { ...prev, price: priceRange };
                }
                return prev;
            });
        }, 150);

        return () => clearTimeout(handler);
    }, [priceRange]);

    // handleClearFilter
    const handleClearFilter = () => {
        sessionStorage.removeItem("selectedLocality");
        sessionStorage.removeItem("SelectedLocalityId");
        sessionStorage.removeItem("selectedLocalityFull");
        sessionStorage.removeItem("roomType");
        sessionStorage.removeItem("priceRange");

        setFilter((prev) => ({
            ...prev,
            selectedLocality: [],
            // RoomType: []
        }));
        setPriceRange(defaultPrice);
    };

    // Start component here

    const renderHeader = (): JSX.Element => {
        return (
            <components.Header
                title=""
                goBack={true}
                skip={true}
                clear={false}
                clearOnClicked={() => { }}
            />
        );
    };

    const renderTitle = (): JSX.Element => {
        return (
            <div className="container" style={{ marginTop: 30 }}>
                <div className="filterHead">
                    {/* <div className='filterWithIcon'>
                        <FilterSvg color='#7065F0' size={20} />
                     
                    </div> */}
                    <p
                        className="headingCity "
                        style={{ textAlign: "left", fontSize: "26px" }}
                    >
                        Filter
                    </p>
                    <p className="filterClear" onClick={handleClearFilter}>
                        {" "}
                        Clear all
                    </p>
                </div>

                <div className="changeCityContainer">
                    <p className="paraCity leftText">
                        Select Locality in{" "}
                        <span className="cityHighlight">{selectedCity}</span>
                    </p>
                    <p
                        className="paraCity leftText boldText"
                        // onClick={() => navigate('/onbording5')}
                        onClick={handleChangeCity}
                    >
                        Change City
                    </p>
                </div>
            </div>
        );
    };

    const renderPriceRangeSelector = (): JSX.Element => {
        const [minVal, maxVal] = priceRange;

        const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = Number(e.target.value);
            if (value < priceRange[1] - minGap) {
                const newRange: [number, number] = [value, priceRange[1]];
                setPriceRange(newRange);
                sessionStorage.setItem("minAmount", value.toString());
                sessionStorage.setItem("maxAmount", priceRange[1].toString());
            }
        };

        const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = Number(e.target.value);
            if (value > priceRange[0] + minGap) {
                const newRange: [number, number] = [priceRange[0], value];
                setPriceRange(newRange);
                sessionStorage.setItem("minAmount", priceRange[0].toString());
                sessionStorage.setItem("maxAmount", value.toString());
            }
        };

        const getLeft = () => ((minVal - minLimit) / (maxLimit - minLimit)) * 100;
        const getWidth = () => ((maxVal - minVal) / (maxLimit - minLimit)) * 100;

        return (
            <div className="container" style={{ marginTop: 10 }}>
                <div style={{ marginBottom: 10, fontSize: 14 }}>
                    ₹{minVal} - ₹{maxVal}
                </div>

                <div style={{ position: "relative", height: 40 }}>
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: "100%",
                            height: 4,
                            backgroundColor: "#ccc",
                            borderRadius: 2,
                            zIndex: 1,
                        }}
                    />
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            transform: "translateY(-50%)",
                            height: 4,
                            backgroundColor: "#7065F0",
                            borderRadius: 2,
                            left: `${getLeft()}%`,
                            width: `${getWidth()}%`,
                            zIndex: 2,
                        }}
                    />

                    <input
                        type="range"
                        min={minLimit}
                        max={maxLimit}
                        value={minVal}
                        onChange={handleMinChange}
                        style={rangeInputStyle}
                    />
                    <input
                        type="range"
                        min={minLimit}
                        max={maxLimit}
                        value={maxVal}
                        onChange={handleMaxChange}
                        style={rangeInputStyle}
                    />
                </div>

                {/* Slider Thumb Styles */}
                <style>
                    {`
        input[type='range'] {
          -webkit-appearance: none;
        }

        input[type='range']::-webkit-slider-thumb {
          -webkit-appearance: none;
          height: 20px;
          width: 20px;
          border-radius: 50%;
          background: white;
          border: 3px solid #7065F0;
          margin-top: -8px;
          cursor: pointer;
          position: relative;
          z-index: 3;
        }

        input[type='range']::-moz-range-thumb {
          height: 20px;
          width: 20px;
          border-radius: 50%;
          background: white;
          border: 3px solid #7065F0;
          cursor: pointer;
          position: relative;
          z-index: 3;
        }
      `}
                </style>
            </div>
        );
    };

    type FilterHeadingProps = {
        title: string;
    };

    const filterHeading = ({ title }: FilterHeadingProps): JSX.Element => {
        return (
            <>
                <div className="container" style={{ marginTop: "30px" }}>
                    <p className="filtertitle">{title}</p>
                </div>
            </>
        );
    };

    // Recent Location Button
    const renderRecentLocationsGrid = (): JSX.Element => {
        return (
            <div className="container">
                <div className="location-tag-group">
                    <div
                        className="addMoreBtn"
                        onClick={() => navigate("/onbording6")}
                        style={{ padding: "10px 25px" }}
                    >
                        + Add More
                    </div>
                    {filter.selectedLocality?.map((city: string, index: number) => (
                        <div
                            key={index}
                            className="location-tag-wrapper"
                            style={{ padding: "10px 25px" }}
                        >
                            {city}
                            <span
                                onClick={() => handleRemoveCity(city)}
                                style={{
                                    position: "absolute",
                                    top: 5,
                                    right: 10,
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                    fontSize: 12,
                                    color: "#999",
                                }}
                                title="Remove"
                            >
                                ×
                            </span>
                        </div>
                    ))}
                </div>

                <style>
                    {`
          @media (min-width: 768px) {
            .recent-locations-grid {
              grid-template-columns: repeat(5, 1fr) !important;
            }
          }

          .recent-locations-grid::-webkit-scrollbar {
            width: 6px;
          }
          .recent-locations-grid::-webkit-scrollbar-thumb {
            background-color: rgba(0, 0, 0, 0.2);
            border-radius: 4px;
          }
        `}
                </style>
            </div>
        );
    };

    // WITH GENDER
    const gender = ["Male", "Female", "Other"];

    const renderRecentLocationsGrid2 = (): JSX.Element => {
        return (
            <div className="container">
                <div className="location-tag-group" style={{ fontSize: "14px" }}>
                    {gender.map((genderOption, index) => (
                        <div
                            key={index}
                            style={{ display: "flex", gap: "10px", marginRight: "12px" }}
                            onClick={() => handleGender(genderOption)}
                        >
                            <input
                                type="radio"
                                id={genderOption}
                                name="gender"
                                checked={filter.gender === genderOption}
                                onChange={() => { }} // dummy to suppress warning for controlled input
                            />
                            <label htmlFor={genderOption}>{genderOption}</label>
                        </div>
                    ))}
                </div>
                {genderError && (
                    <p style={{ color: "red", fontSize: "14px", marginTop: 6 }}>
                        {genderError}
                    </p>
                )}
            </div>
        );
    };

    const propertyTypes = ["Male", "Female", "Other"];

    useEffect(() => {
        sessionStorage.setItem("roomType", filter.RoomType);
        // const saved = sessionStorage.getItem("roomType");

        // if (saved), filter.RoomType {
        //     const parsed = JSON.parse(saved)
        //     console.log(parsed, 'parsed Value');
        //     setFilter(prev => ({
        //         ...prev, RoomType: parsed
        //     }))
        // }
    }, []);

    const renderButton = (): JSX.Element => {
        return (
            <div>
                <components.Button
                    title="See all properties"
                    style={{
                        backgroundColor: "#7065F0",
                        color: "#fff",
                        border: "1px solid #7065F0",
                    }}
                    onClick={() => {
                        if (!filter.gender) {
                            setGenderError("⚠️ Please select a gender.");
                            return;
                        }

                        setGenderError(""); // Clear error before navigation
                        navigate("/serach-result", { state: { filter } });
                    }}
                />
            </div>
        );
    };

    const renderContent = (): JSX.Element => {
        return (
            <main
                className=""
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100dvh",
                    paddingBottom: 25,
                    overflow: "hidden",
                }}
            >
                <div style={{ overflow: "auto" }}>
                    {renderTitle()}

                    {filterHeading({ title: "Recently Selected Localities" })}
                    {renderRecentLocationsGrid()}
                    {filterHeading({ title: "Gender" })}
                    {renderRecentLocationsGrid2()}

                    {filterHeading({ title: "Select Price Range (₹)" })}
                    {renderPriceRangeSelector()}
                </div>
                <div
                    style={{
                        paddingRight: 20,
                        paddingLeft: 20,
                    }}
                >
                    {renderButton()}
                </div>
            </main>
        );
    };

    return (
        <>
            {renderHeader()}
            {renderContent()}
        </>
    );
};

// 08-07-2025 CODE
// import React, { useState, useEffect } from 'react';
// import { useFetcher, useLocation } from 'react-router-dom';

// import { text } from '../text';
// import { hooks } from '../hooks';
// import { utils } from '../utils';
// import { svg } from '../assets/svg';
// import { theme } from '../constants';
// import { components } from '../components';
// import { colors } from '../constants/colors';
// import { FilterSvg } from '../assets/svg/FilterSvg';

// const price = [
//     {
//         id: 1,
//         name: 'Paid (142)',
//     },
//     {
//         id: 2,
//         name: 'Free (18)',
//     },
// ];

// export const Onboarding7: React.FC = () => {
//     const location = useLocation();
//     const { pathname } = useLocation();
//     const defaultPrice: [number, number] = [2000, 8000];
//     // const [priceRange, setPriceRange] = useState<[number, number]>(() => {
//     //     const saved = sessionStorage.getItem("priceRange");
//     //     return saved ? JSON.parse(saved) : defaultPrice;
//     // });

//     // const minLimit = 1000;  // Minimum possible value
//     // const maxLimit = 100000; // Maximum possible value
//     // const minGap = 500; // Minimum gap between min and max (to avoid overlap)
//     const [priceRange, setPriceRange] = useState<[number, number]>([1000, 20000]); // default range
// const minLimit = 1000;
// const maxLimit = 50000;
// const minGap = 500;

//     const selectedCity = sessionStorage.getItem("selectedCity")

//     const [genderError, setGenderError] = useState<string>("");
//     const [priceError, setPriceError] = useState<string>("");

//     const [filter, setFilter] = useState<{
//         selectedLocality: string[];
//         gender: string;
//         price: [number, number];
//         RoomType: string;
//     }>({
//         selectedLocality: [],
//         gender: "",
//         price: [2000, 8000],
//         RoomType: "PG",
//     });

//     useEffect(() => {
//     const storedMin = sessionStorage.getItem("minAmount");
//     const storedMax = sessionStorage.getItem("maxAmount");

//     if (storedMin && storedMax) {
//         const min = Number(storedMin);
//         const max = Number(storedMax);
//         if (!isNaN(min) && !isNaN(max) && min < max) {
//             setPriceRange([min, max]);
//         }
//     }
// }, []);

//     const rangeInputStyle: React.CSSProperties = {
//         position: 'absolute',
//         top: 22,
//         width: '100%',
//         height: '4px',
//         background: 'transparent',
//         pointerEvents: 'auto',
//         zIndex: 4,
//     };

// useEffect(() => {
//     const storedGender = sessionStorage.getItem('gender');
//     if (storedGender) {
//         setFilter(prev => ({
//             ...prev,
//             gender: storedGender
//         }));
//     }
// }, []);

//     useEffect(() => {
//         const scrollToTop = () => {
//             window.scrollTo(0, 0);
//             document.documentElement.scrollTop = 0;
//         };

//         scrollToTop();
//     }, [pathname]);

//     const navigate = hooks.useNavigate();

//     const [selectedPrice, setSelectedPrice] = useState<number | null>(price[0].id);

//     // handle locality here
//     useEffect(() => {
//         const selectedLocality = sessionStorage.getItem("selectedLocality");
//         if (selectedLocality) {
//             try {
//                 const parsedLocality = JSON.parse(selectedLocality);
//                 setFilter(prevFilter => ({
//                     ...prevFilter,
//                     selectedLocality: parsedLocality
//                 }));
//             } catch (error) {
//                 console.error("Failed to parse selectedLocality:", error);
//             }
//         }
//     }, []);

//     //handlePropertyTypeClick
//     // const handlePropertyTypeClick = (propertyType: string) => {
//     //     setFilter(prevFilter => {
//     //         // Toggle selection - if already selected, remove it; otherwise add it
//     //         const updatedRoomTypes = prevFilter.RoomType.includes(propertyType)
//     //             ? prevFilter.RoomType.filter(type => type !== propertyType)
//     //             : [...prevFilter.RoomType, propertyType];

//     //         console.log(updatedRoomTypes);
//     //         sessionStorage.setItem("roomType", JSON.stringify(updatedRoomTypes))
//     //         return {
//     //             ...prevFilter,
//     //             RoomType: updatedRoomTypes
//     //         };
//     //     });
//     // };

//     // Gender

//     const handleGender = (inputGender: string) => {
//         setFilter(prevFilter => {
//             const updateFilter = {
//                 ...prevFilter,
//                 gender: inputGender
//             }
//             // console.log(inputGender, "this is input Gender");
//             setGenderError(""); // ✅ Clear error
//              let genderKey = "";

//     switch (inputGender.toLowerCase()) {
//         case "male":
//             genderKey = "GENDER_MALE";
//             break;
//         case "female":
//             genderKey = "GENDER_FEMALE";
//             break;
//         case "other":
//             genderKey = "GENDER_OTHER";
//             break;
//         default:
//             genderKey = "GENDER_UNSPECIFIED";
//     }

//      // Save mapped value to sessionStorage for API
//         sessionStorage.setItem("genderAPI", genderKey);
//             sessionStorage.setItem('gender', inputGender);
//             return updateFilter;
//         })
//     }

//     // const handleGender = (inputGender: string) => {

//     //     setFilter(prevFilter => {
//     //         const updatedGenderFilter = {
//     //             ...prevFilter,
//     //             gender: inputGender
//     //         }
//     //         sessionStorage.setItem("gender", inputGender)
//     //         return updatedGenderFilter;

//     //     }

//     // const handleRemoveCity = (cityToRemove: string) => {
//     //     const updatedLocality = filter.selectedLocality.filter(
//     //         (item) => item !== cityToRemove
//     //     );
//     //     setFilter(prevFilter => ({
//     //         ...prevFilter,
//     //         selectedLocality: updatedLocality
//     //     }));
//     //     sessionStorage.setItem("selectedLocality", JSON.stringify(updatedLocality));
//     // };

// const handleRemoveCity = (cityToRemove: string) => {
//   // Step 1: Update selectedLocality (names)
//   const updatedLocality = filter.selectedLocality.filter(
//     (item) => item !== cityToRemove
//   );

//   setFilter((prevFilter) => ({
//     ...prevFilter,
//     selectedLocality: updatedLocality,
//   }));

//   sessionStorage.setItem("selectedLocality", JSON.stringify(updatedLocality));

//   // Step 2: Update SelectedLocalityId
//   const fullListRaw = sessionStorage.getItem("selectedLocalityFull");
//   const fullList = fullListRaw ? JSON.parse(fullListRaw) : [];

//   // Find ID to remove
//   const cityObj = fullList.find(
//     (loc: { locality_name: string }) => loc.locality_name === cityToRemove
//   );
//   if (!cityObj) return;

//   const cityIdToRemove = String(cityObj.locality_id);

//   const existingIdsRaw = sessionStorage.getItem("SelectedLocalityId");
//   const existingIds = existingIdsRaw
//     ? existingIdsRaw.split(",").map((id) => id.trim())
//     : [];

//   const updatedIds = existingIds.filter((id) => id !== cityIdToRemove);
//   sessionStorage.setItem("SelectedLocalityId", updatedIds.join(", "));

//   // Step 3: Update selectedLocalityFull
//   const updatedFullList = fullList.filter(
//     (loc: { locality_name: string }) => loc.locality_name !== cityToRemove
//   );
//   sessionStorage.setItem("selectedLocalityFull", JSON.stringify(updatedFullList));
// };

//     useEffect(() => {
//         console.log("Updated filter:", filter);
//     }, [filter]);

//     const handleChangeCity = () => {
//         sessionStorage.clear()
//         navigate('/onbording5')
//     }

//     // Debounced effect
//     useEffect(() => {
//         const handler = setTimeout(() => {
//             setFilter(prev => {
//                 if (prev.price[0] !== priceRange[0] || prev.price[1] !== priceRange[1]) {
//                     return { ...prev, price: priceRange };
//                 }
//                 return prev;
//             });
//         }, 150);

//         return () => clearTimeout(handler);
//     }, [priceRange]);

//     // handleClearFilter
//     const handleClearFilter = () => {
//         sessionStorage.removeItem("selectedLocality")
//           sessionStorage.removeItem("SelectedLocalityId");
//   sessionStorage.removeItem("selectedLocalityFull");
//         sessionStorage.removeItem("roomType")
//         sessionStorage.removeItem("priceRange")

//         setFilter(prev => ({
//             ...prev,
//             selectedLocality: [],
//             // RoomType: []
//         }));
//         setPriceRange(defaultPrice)

//     }

//     // Start component here

//     const renderHeader = (): JSX.Element => {
//         return (
//             <components.Header
//                 title=''
//                 goBack={true}
//                 skip={true}
//                 clear={false}
//                 clearOnClicked={() => { }}
//             />
//         );
//     };

//     const renderTitle = (): JSX.Element => {
//         return (
//             <div className='container' style={{ marginTop: 30 }}>
//                 <div className='filterHead'>
//                     {/* <div className='filterWithIcon'>
//                         <FilterSvg color='#7065F0' size={20} />

//                     </div> */}
//                     <p className='headingCity ' style={{ textAlign: "left", fontSize: "26px" }}>
//                         Filter
//                     </p>
//                     <p className='filterClear' onClick={handleClearFilter}> Clear all</p>
//                 </div>

//                 <div className='changeCityContainer'>
//                     <p className='paraCity leftText'>
//                         Select Locality in <span className="cityHighlight">{selectedCity}</span>
//                     </p>
//                     <p className='paraCity leftText boldText'
//                         // onClick={() => navigate('/onbording5')}
//                         onClick={handleChangeCity}
//                     >Change City</p>
//                 </div>

//             </div>
//         );
//     };

// const renderPriceRangeSelector = (): JSX.Element => {
//     const [minVal, maxVal] = priceRange;

//     const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const value = Number(e.target.value);
//         if (value < priceRange[1] - minGap) {
//             const newRange: [number, number] = [value, priceRange[1]];
//             setPriceRange(newRange);
//             sessionStorage.setItem("minAmount", value.toString());
//             sessionStorage.setItem("maxAmount", priceRange[1].toString());
//         }
//     };

//     const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const value = Number(e.target.value);
//         if (value > priceRange[0] + minGap) {
//             const newRange: [number, number] = [priceRange[0], value];
//             setPriceRange(newRange);
//             sessionStorage.setItem("minAmount", priceRange[0].toString());
//             sessionStorage.setItem("maxAmount", value.toString());
//         }
//     };

//     const getLeft = () => ((minVal - minLimit) / (maxLimit - minLimit)) * 100;
//     const getWidth = () =>
//         ((maxVal - minVal) / (maxLimit - minLimit)) * 100;

//     return (
//         <div className="container" style={{ marginTop: 10 }}>
//             <div style={{ marginBottom: 10, fontSize: 14 }}>
//                 ₹{minVal} - ₹{maxVal}
//             </div>

//             <div style={{ position: 'relative', height: 40 }}>
//                 <div
//                     style={{
//                         position: 'absolute',
//                         top: '50%',
//                         transform: 'translateY(-50%)',
//                         width: '100%',
//                         height: 4,
//                         backgroundColor: '#ccc',
//                         borderRadius: 2,
//                         zIndex: 1,
//                     }}
//                 />
//                 <div
//                     style={{
//                         position: 'absolute',
//                         top: '50%',
//                         transform: 'translateY(-50%)',
//                         height: 4,
//                         backgroundColor: '#7065F0',
//                         borderRadius: 2,
//                         left: `${getLeft()}%`,
//                         width: `${getWidth()}%`,
//                         zIndex: 2,
//                     }}
//                 />

//                 <input
//                     type="range"
//                     min={minLimit}
//                     max={maxLimit}
//                     value={minVal}
//                     onChange={handleMinChange}
//                     style={rangeInputStyle}
//                 />
//                 <input
//                     type="range"
//                     min={minLimit}
//                     max={maxLimit}
//                     value={maxVal}
//                     onChange={handleMaxChange}
//                     style={rangeInputStyle}
//                 />
//             </div>

//             {/* Slider Thumb Styles */}
//             <style>
//                 {`
//         input[type='range'] {
//           -webkit-appearance: none;
//         }

//         input[type='range']::-webkit-slider-thumb {
//           -webkit-appearance: none;
//           height: 20px;
//           width: 20px;
//           border-radius: 50%;
//           background: white;
//           border: 3px solid #7065F0;
//           margin-top: -8px;
//           cursor: pointer;
//           position: relative;
//           z-index: 3;
//         }

//         input[type='range']::-moz-range-thumb {
//           height: 20px;
//           width: 20px;
//           border-radius: 50%;
//           background: white;
//           border: 3px solid #7065F0;
//           cursor: pointer;
//           position: relative;
//           z-index: 3;
//         }
//       `}
//             </style>
//         </div>
//     );
// };

//     type FilterHeadingProps = {
//         title: string;
//     };

//     const filterHeading = ({ title }: FilterHeadingProps): JSX.Element => {
//         return (
//             <>
//                 <div className='container' style={{ marginTop: "30px" }}>
//                     <p className="filtertitle">{title}</p>
//                 </div>
//             </>
//         );
//     };

//     // Recent Location Button
//     const renderRecentLocationsGrid = (): JSX.Element => {
//         return (
//             <div className="container" >

//                 <div className="location-tag-group" >
//                     <div className='addMoreBtn' onClick={() => navigate('/onbording6')} style={{ padding: "10px 25px" }} >+ Add More</div>
//                     {filter.selectedLocality?.map((city: string, index: number) => (
//                         <div key={index} className="location-tag-wrapper" style={{ padding: "10px 25px" }} >
//                             {city}
//                             <span
//                                 onClick={() => handleRemoveCity(city)}
//                                 style={{
//                                     position: 'absolute',
//                                     top: 5,
//                                     right: 10,
//                                     cursor: 'pointer',
//                                     fontWeight: 'bold',
//                                     fontSize: 12,
//                                     color: '#999',
//                                 }}
//                                 title="Remove"

//                             >
//                                 ×
//                             </span>
//                         </div>
//                     ))}
//                 </div>

//                 {/* <div
//                     style={{
//                         maxHeight: 120,
//                         overflowY: 'auto',
//                     }}
//                 >
//                     <div
//                         className="recent-locations-grid"
//                         style={{
//                             display: 'grid',
//                             gap: 10,
//                             gridTemplateColumns: 'repeat(3, 1fr)',
//                         }}
//                     >
//                         {recentLocations.map((city, index) => (
//                             <div
//                                 key={index}
//                                 style={{
//                                     position: 'relative',
//                                     padding: '12px',
//                                     border: '1px solid #ccc',
//                                     borderRadius: 5,
//                                     textAlign: 'center',
//                                     fontSize: 14,
//                                     backgroundColor: '#f9f9f9',
//                                 }}
//                             >
//                                 {city}
//                                 <span
//                                     onClick={() => handleRemoveCity(city)}
//                                     style={{
//                                         position: 'absolute',
//                                         top: 4,
//                                         right: 6,
//                                         cursor: 'pointer',
//                                         fontWeight: 'bold',
//                                         fontSize: 12,
//                                         color: '#999',
//                                     }}
//                                     title="Remove"
//                                 >
//                                     ×
//                                 </span>
//                             </div>
//                         ))}
//                     </div>
//                 </div> */}

//                 <style>
//                     {`
//           @media (min-width: 768px) {
//             .recent-locations-grid {
//               grid-template-columns: repeat(5, 1fr) !important;
//             }
//           }

//           .recent-locations-grid::-webkit-scrollbar {
//             width: 6px;
//           }
//           .recent-locations-grid::-webkit-scrollbar-thumb {
//             background-color: rgba(0, 0, 0, 0.2);
//             border-radius: 4px;
//           }
//         `}
//                 </style>
//             </div>
//         );
//     };

//       // WITH GENDER
//     const gender = ["Male", "Female", "Other"]

// const renderRecentLocationsGrid2 = (): JSX.Element => {
//     return (
//         <div className="container">
//             <div className="location-tag-group" style={{ fontSize: "14px" }}>
//                 {gender.map((genderOption, index) => (
//                     <div
//                         key={index}
//                         style={{ display: "flex", gap: "10px", marginRight: "12px" }}
//                         onClick={() => handleGender(genderOption)}
//                     >
//                         <input
//                             type="radio"
//                             id={genderOption}
//                             name="gender"
//                             checked={filter.gender === genderOption}
//                             onChange={() => {}} // dummy to suppress warning for controlled input
//                          />
//                         <label htmlFor={genderOption}>{genderOption}</label>
//                     </div>
//                 ))}
//             </div>
//         {genderError && (
//         <p style={{ color: 'red', fontSize: '14px', marginTop: 6 }}>
//           {genderError}
//         </p>
//       )}
//         </div>
//     );
// };

//     // const renderRecentLocationsGrid2 = (): JSX.Element => {
//     //     return (
//     //         <div className="container" >
//     //             <div className="location-tag-group">
//     //                 {propertyTypes.map((city, index) => (
//     //                     <div key={index} className="location-tag-wrapper" style={{ padding: "10px 25px" }}>
//     //                         {city}
//     //                     </div>
//     //                 ))}
//     //             </div>
//     //             <style>
//     //                 {`
//     //       @media (min-width: 768px) {
//     //         .recent-locations-grid {
//     //           grid-template-columns: repeat(5, 1fr) !important;
//     //         }
//     //       }

//     //       .recent-locations-grid::-webkit-scrollbar {
//     //         width: 6px;
//     //       }
//     //       .recent-locations-grid::-webkit-scrollbar-thumb {
//     //         background-color: rgba(0, 0, 0, 0.2);
//     //         border-radius: 4px;
//     //       }
//     //     `}
//     //             </style>
//     //         </div>
//     //     );
//     // };

//     const propertyTypes = ['Male', 'Female', 'Other'];
//     // const propertyTypes = ['PG', 'Flat'];

//     // const propertyTypes2 = JSON.parse((sessionStorage.getItem("roomType") || "[]"))

//     useEffect(() => {

//         sessionStorage.setItem("roomType", filter.RoomType);
//         // const saved = sessionStorage.getItem("roomType");

//         // if (saved), filter.RoomType {
//         //     const parsed = JSON.parse(saved)
//         //     console.log(parsed, 'parsed Value');
//         //     setFilter(prev => ({
//         //         ...prev, RoomType: parsed
//         //     }))
//         // }
//     }, [])

// const renderButton = (): JSX.Element => {
//   return (
//     <div>
//       <components.Button
//         title='See all properties'
//         style={{
//           backgroundColor: '#7065F0',
//           color: '#fff',
//           border: '1px solid #7065F0',
//         }}
//         onClick={() => {
//           if (!filter.gender) {
//             setGenderError("⚠️ Please select a gender.");
//             return;
//           }

//           setGenderError(""); // Clear error before navigation
//           navigate('/serach-result', { state: { filter } });
//         }}
//       />

//     </div>
//   );
// };

//     // const renderButton = (): JSX.Element => {
//     //     return (
//     //         <components.Button
//     //             title='See all properties'
//     //             style={{
//     //                 backgroundColor: '#7065F0',
//     //                 color: '#fff',
//     //                 border: '1px solid #7065F0',
//     //             }}
//     //             onClick={() => navigate('/serach-result', { state: { filter } })}
//     //         />
//     //     );
//     // };

//     const renderContent = (): JSX.Element => {
//         return (
//             <main
//                 className=''
//                 style={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'space-between',
//                     height: '100dvh',
//                     paddingBottom: 25,
//                     overflow: 'hidden'
//                 }}
//             >
//                 <div style={{ overflow: "auto" }}>
//                     {renderTitle()}

//                     {filterHeading({ title: "Recently Selected Localities" })}
//                     {renderRecentLocationsGrid()}
//                     {filterHeading({ title: "Gender" })}
//                     {renderRecentLocationsGrid2()}

//                     {filterHeading({ title: "Select Price Range (₹)" })}
//                     {renderPriceRangeSelector()}
//                 </div>
//                 <div style={{
//                     paddingRight: 20,
//                     paddingLeft: 20,
//                 }}>
//                     {renderButton()}
//                 </div>
//             </main>
//         );
//     };

//     return (
//         <>
//             {renderHeader()}
//             {renderContent()}
//         </>
//     );
// };

// // *********************
// import React, { useState, useEffect } from 'react';
// import { useFetcher, useLocation } from 'react-router-dom';

// import { text } from '../text';
// import { hooks } from '../hooks';
// import { utils } from '../utils';
// import { svg } from '../assets/svg';
// import { theme } from '../constants';
// import { components } from '../components';
// import { colors } from '../constants/colors';
// import { FilterSvg } from '../assets/svg/FilterSvg';

// const price = [
//     {
//         id: 1,
//         name: 'Paid (142)',
//     },
//     {
//         id: 2,
//         name: 'Free (18)',
//     },
// ];

// export const Onboarding7: React.FC = () => {
//     const location = useLocation();
//     const { pathname } = useLocation();
//     const defaultPrice: [number, number] = [2000, 8000];
//     const [priceRange, setPriceRange] = useState<[number, number]>(() => {
//         const saved = sessionStorage.getItem("priceRange");
//         return saved ? JSON.parse(saved) : defaultPrice;
//     });

//     const minLimit = 1000;  // Minimum possible value
//     const maxLimit = 100000; // Maximum possible value
//     const minGap = 500; // Minimum gap between min and max (to avoid overlap)
//     const selectedCity = sessionStorage.getItem("selectedCity")

//     // const [filter, setFilter] = useState({
//     //     selectedLocality: [] as string[],
//     //     RoomType: [] as string[],
//     //     price: []
//     // });

//     const [filter, setFilter] = useState<{
//         selectedLocality: string[];
//         gender: string;
//         price: [number, number];
//         // RoomType: string[];
//     }>({
//         selectedLocality: [],
//         gender: "Male",
//         price: [2000, 8000],
//         // RoomType: [],
//     });

//     const rangeInputStyle: React.CSSProperties = {
//         position: 'absolute',
//         top: 22,
//         width: '100%',
//         height: '4px',
//         background: 'transparent',
//         pointerEvents: 'auto',
//         zIndex: 4,
//     };

//     useEffect(() => {
//         const scrollToTop = () => {
//             window.scrollTo(0, 0);
//             document.documentElement.scrollTop = 0;
//         };

//         scrollToTop();
//     }, [pathname]);

//     const navigate = hooks.useNavigate();

//     const [selectedPrice, setSelectedPrice] = useState<number | null>(price[0].id);

//     // handle locality here
//     useEffect(() => {
//         const selectedLocality = sessionStorage.getItem("selectedLocality");
//         if (selectedLocality) {
//             try {
//                 const parsedLocality = JSON.parse(selectedLocality);
//                 setFilter(prevFilter => ({
//                     ...prevFilter,
//                     selectedLocality: parsedLocality
//                 }));
//             } catch (error) {
//                 console.error("Failed to parse selectedLocality:", error);
//             }
//         }
//     }, []);

//     //handlePropertyTypeClick
//     // const handlePropertyTypeClick = (propertyType: string) => {
//     //     setFilter(prevFilter => {
//     //         // Toggle selection - if already selected, remove it; otherwise add it
//     //         const updatedRoomTypes = prevFilter.RoomType.includes(propertyType)
//     //             ? prevFilter.RoomType.filter(type => type !== propertyType)
//     //             : [...prevFilter.RoomType, propertyType];

//     //         console.log(updatedRoomTypes);
//     //         sessionStorage.setItem("roomType", JSON.stringify(updatedRoomTypes))
//     //         return {
//     //             ...prevFilter,
//     //             RoomType: updatedRoomTypes
//     //         };
//     //     });
//     // };

//     // Gender

//     const handleGender = (inputGender: string) => {
//         setFilter(prevFilter => {
//             const updateFilter = {
//                 ...prevFilter,
//                 gender: inputGender
//             }
//             sessionStorage.setItem('gender', inputGender);
//             return updateFilter;
//         })
//     }

//     // const handleGender = (inputGender: string) => {

//     //     setFilter(prevFilter => {
//     //         const updatedGenderFilter = {
//     //             ...prevFilter,
//     //             gender: inputGender
//     //         }
//     //         sessionStorage.setItem("gender", inputGender)
//     //         return updatedGenderFilter;

//     //     }

//     const handleRemoveCity = (cityToRemove: string) => {
//         const updatedLocality = filter.selectedLocality.filter(
//             (item) => item !== cityToRemove
//         );

//         setFilter(prevFilter => ({
//             ...prevFilter,
//             selectedLocality: updatedLocality
//         }));

//         sessionStorage.setItem("selectedLocality", JSON.stringify(updatedLocality));
//     };

//     useEffect(() => {
//         console.log("Updated filter:", filter);
//     }, [filter]);

//     const handleChangeCity = () => {
//         sessionStorage.clear()
//         navigate('/onbording5')
//     }

//     // Debounced effect
//     useEffect(() => {
//         const handler = setTimeout(() => {
//             setFilter(prev => {
//                 if (prev.price[0] !== priceRange[0] || prev.price[1] !== priceRange[1]) {
//                     return { ...prev, price: priceRange };
//                 }
//                 return prev;
//             });
//         }, 150);

//         return () => clearTimeout(handler);
//     }, [priceRange]);

//     // handleClearFilter
//     const handleClearFilter = () => {
//         sessionStorage.removeItem("selectedLocality")
//         sessionStorage.removeItem("roomType")
//         sessionStorage.removeItem("priceRange")

//         setFilter(prev => ({
//             ...prev,
//             selectedLocality: [],
//             RoomType: []
//         }));
//         setPriceRange(defaultPrice)

//     }

//     // Start component here

//     const renderHeader = (): JSX.Element => {
//         return (
//             <components.Header
//                 title=''
//                 goBack={true}
//                 skip={true}
//                 clear={false}
//                 clearOnClicked={() => { }}
//             />
//         );
//     };

//     const renderTitle = (): JSX.Element => {
//         return (
//             <div className='container' style={{ marginTop: 30 }}>
//                 <div className='filterHead'>
//                     {/* <div className='filterWithIcon'>
//                         <FilterSvg color='#7065F0' size={20} />

//                     </div> */}
//                     <p className='headingCity ' style={{ textAlign: "left", fontSize: "26px" }}>
//                         Filter
//                     </p>
//                     <p className='filterClear' onClick={handleClearFilter}> Clear all</p>
//                 </div>

//                 <div className='changeCityContainer'>
//                     <p className='paraCity leftText'>
//                         Select Locality in <span className="cityHighlight">{selectedCity}</span>
//                     </p>
//                     <p className='paraCity leftText boldText'
//                         // onClick={() => navigate('/onbording5')}
//                         onClick={handleChangeCity}
//                     >Change City</p>
//                 </div>

//             </div>
//         );
//     };

//     const renderPriceRangeSelector = (): JSX.Element => {
//         const [minVal, maxVal] = priceRange;

//         // const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         //     const value = Number(e.target.value);
//         //     if (value < maxVal - minGap) {
//         //         setPriceRange([value, maxVal]);
//         //     }
//         // };

//         // const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         //     const value = Number(e.target.value);
//         //     if (value > minVal + minGap) {
//         //         setPriceRange([minVal, value]);
//         //     }
//         // };

//         const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//             const value = Number(e.target.value);
//             if (value < priceRange[1] - minGap) {
//                 const newRange: [number, number] = [value, priceRange[1]];
//                 setPriceRange(newRange);
//                 sessionStorage.setItem("priceRange", JSON.stringify(newRange));
//             }
//         };

//         const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//             const value = Number(e.target.value);
//             if (value > priceRange[0] + minGap) {
//                 const newRange: [number, number] = [priceRange[0], value];
//                 setPriceRange(newRange);
//                 sessionStorage.setItem("priceRange", JSON.stringify(newRange));
//             }
//         };

//         const getLeft = () => ((minVal - minLimit) / (maxLimit - minLimit)) * 100;
//         const getWidth = () =>
//             ((maxVal - minVal) / (maxLimit - minLimit)) * 100;

//         return (
//             <div className="container" style={{ marginTop: 10 }}>

//                 <div style={{ marginBottom: 10, fontSize: 14 }}>
//                     ₹{minVal} - ₹{maxVal}
//                 </div>

//                 {/* Slider Wrapper */}
//                 <div style={{ position: 'relative', height: 40 }}>
//                     {/* Background track */}
//                     <div
//                         style={{
//                             position: 'absolute',
//                             top: '50%',
//                             transform: 'translateY(-50%)',
//                             width: '100%',
//                             height: 4,
//                             backgroundColor: '#ccc',
//                             borderRadius: 2,
//                             zIndex: 1,
//                         }}
//                     />

//                     {/* Active range track */}
//                     <div
//                         style={{
//                             position: 'absolute',
//                             top: '50%',
//                             transform: 'translateY(-50%)',
//                             height: 4,
//                             backgroundColor: '#7065F0',
//                             borderRadius: 2,
//                             left: `${getLeft()}%`,
//                             width: `${getWidth()}%`,
//                             zIndex: 2,
//                         }}
//                     />

//                     {/* Range sliders */}
//                     <input
//                         type="range"
//                         min={minLimit}
//                         max={maxLimit}
//                         value={minVal}
//                         onChange={handleMinChange}
//                         style={rangeInputStyle}
//                     />
//                     <input
//                         type="range"
//                         min={minLimit}
//                         max={maxLimit}
//                         value={maxVal}
//                         onChange={handleMaxChange}
//                         style={rangeInputStyle}
//                     />
//                 </div>

//                 {/* Thumb Styles */}
//                 <style>
//                     {`
//         input[type='range'] {
//           -webkit-appearance: none;
//         }

//         input[type='range']::-webkit-slider-thumb {
//           -webkit-appearance: none;
//           height: 20px;
//           width: 20px;
//           border-radius: 50%;
//           background: white;
//           border: 3px solid #7065F0;
//           margin-top: -8px;
//           cursor: pointer;
//           position: relative;
//           z-index: 3;
//         }

//         input[type='range']::-moz-range-thumb {
//           height: 20px;
//           width: 20px;
//           border-radius: 50%;
//           background: white;
//           border: 3px solid #7065F0;
//           cursor: pointer;
//           position: relative;
//           z-index: 3;
//         }
//       `}
//                 </style>
//             </div>
//         );
//     };

//     type FilterHeadingProps = {
//         title: string;
//     };

//     const filterHeading = ({ title }: FilterHeadingProps): JSX.Element => {
//         return (
//             <>
//                 <div className='container' style={{ marginTop: "30px" }}>
//                     <p className="filtertitle">{title}</p>
//                 </div>
//             </>
//         );
//     };

//     // Recent Location Button
//     const renderRecentLocationsGrid = (): JSX.Element => {
//         return (
//             <div className="container" >

//                 <div className="location-tag-group" >
//                     <div className='addMoreBtn' onClick={() => navigate('/onbording6')} style={{ padding: "10px 25px" }} >+ Add More</div>
//                     {filter.selectedLocality?.map((city: string, index: number) => (
//                         <div key={index} className="location-tag-wrapper" style={{ padding: "10px 25px" }} >
//                             {city}
//                             <span
//                                 onClick={() => handleRemoveCity(city)}
//                                 style={{
//                                     position: 'absolute',
//                                     top: 5,
//                                     right: 10,
//                                     cursor: 'pointer',
//                                     fontWeight: 'bold',
//                                     fontSize: 12,
//                                     color: '#999',
//                                 }}
//                                 title="Remove"

//                             >
//                                 ×
//                             </span>
//                         </div>
//                     ))}
//                 </div>

//                 {/* <div
//                     style={{
//                         maxHeight: 120,
//                         overflowY: 'auto',
//                     }}
//                 >
//                     <div
//                         className="recent-locations-grid"
//                         style={{
//                             display: 'grid',
//                             gap: 10,
//                             gridTemplateColumns: 'repeat(3, 1fr)',
//                         }}
//                     >
//                         {recentLocations.map((city, index) => (
//                             <div
//                                 key={index}
//                                 style={{
//                                     position: 'relative',
//                                     padding: '12px',
//                                     border: '1px solid #ccc',
//                                     borderRadius: 5,
//                                     textAlign: 'center',
//                                     fontSize: 14,
//                                     backgroundColor: '#f9f9f9',
//                                 }}
//                             >
//                                 {city}
//                                 <span
//                                     onClick={() => handleRemoveCity(city)}
//                                     style={{
//                                         position: 'absolute',
//                                         top: 4,
//                                         right: 6,
//                                         cursor: 'pointer',
//                                         fontWeight: 'bold',
//                                         fontSize: 12,
//                                         color: '#999',
//                                     }}
//                                     title="Remove"
//                                 >
//                                     ×
//                                 </span>
//                             </div>
//                         ))}
//                     </div>
//                 </div> */}

//                 <style>
//                     {`
//           @media (min-width: 768px) {
//             .recent-locations-grid {
//               grid-template-columns: repeat(5, 1fr) !important;
//             }
//           }

//           .recent-locations-grid::-webkit-scrollbar {
//             width: 6px;
//           }
//           .recent-locations-grid::-webkit-scrollbar-thumb {
//             background-color: rgba(0, 0, 0, 0.2);
//             border-radius: 4px;
//           }
//         `}
//                 </style>
//             </div>
//         );
//     };

//     // Room Type Component

//     // OLD
//     // const renderRecentLocationsGrid2 = (): JSX.Element => {
//     //     return (
//     //         <div className="container">
//     //             <div className="location-tag-group">
//     //                 {propertyTypes.map((propertyType, index) => (
//     //                     <div
//     //                         key={index}
//     //                         className={`location-tag-wrapper ${filter.RoomType.includes(propertyType) ? 'selected' : ''
//     //                             }`}
//     //                         onClick={() => handlePropertyTypeClick(propertyType)}
//     //                     >
//     //                         {propertyType}
//     //                     </div>
//     //                 ))}
//     //             </div>
//     //         </div>
//     //     );
//     // };

//     // WITH GENDER
//     const gender = ["Male", "Female", "Other"]

//     const renderRecentLocationsGrid2 = (): JSX.Element => {
//         return (
//             <div className="container">
//                 <div className="location-tag-group" style={{ fontSize: "14px" }}>

//                     {/* <input type="radio" id="html" name="fav_language" value="HTML"/>
//                         <label for="html">HTML</label> */}

//                     {
//                         gender.map((gender, index) => (
//                             // <h1>{gender}</h1>
//                             <div style={{ display: "flex", gap: "10px", marginRight: "12px" }} onClick={() => handleGender(gender)}>
//                                 <input type="radio" id={gender} name='gender' />
//                                 <label htmlFor={gender}>{gender}</label>
//                             </div>
//                         ))
//                     }

//                     {/* <input type="radio" id='male' name='gender' />
//                     <label htmlFor='male'>Male</label>
//                     <input type="radio" id='female' name='gender' />
//                     <label htmlFor="female" >Female</label>
//                     <input type="radio" id='other' name='gender' />
//                     <label htmlFor="other">Other</label> */}

//                     {/* {propertyTypes.map((propertyType, index) => (
//                         <div
//                             key={index}
//                             className={`location-tag-wrapper ${filter.RoomType.includes(propertyType) ? 'selected' : ''
//                                 }`}
//                             onClick={() => handlePropertyTypeClick(propertyType)}
//                         >
//                             {propertyType}
//                         </div>
//                     ))} */}
//                 </div>
//             </div>
//         );
//     };

//     // const renderRecentLocationsGrid2 = (): JSX.Element => {
//     //     return (
//     //         <div className="container" >
//     //             <div className="location-tag-group">
//     //                 {propertyTypes.map((city, index) => (
//     //                     <div key={index} className="location-tag-wrapper" style={{ padding: "10px 25px" }}>
//     //                         {city}
//     //                     </div>
//     //                 ))}
//     //             </div>
//     //             <style>
//     //                 {`
//     //       @media (min-width: 768px) {
//     //         .recent-locations-grid {
//     //           grid-template-columns: repeat(5, 1fr) !important;
//     //         }
//     //       }

//     //       .recent-locations-grid::-webkit-scrollbar {
//     //         width: 6px;
//     //       }
//     //       .recent-locations-grid::-webkit-scrollbar-thumb {
//     //         background-color: rgba(0, 0, 0, 0.2);
//     //         border-radius: 4px;
//     //       }
//     //     `}
//     //             </style>
//     //         </div>
//     //     );
//     // };

//     const propertyTypes = ['Male', 'Female', 'Other'];
//     // const propertyTypes = ['PG', 'Flat'];

//     // const propertyTypes2 = JSON.parse((sessionStorage.getItem("roomType") || "[]"))

//     useEffect(() => {
//         // const saved = sessionStorage.getItem("roomType");
//         // if (saved) {
//         //     const parsed = JSON.parse(saved)
//         //     console.log(parsed, 'parsed Value');
//         //     setFilter(prev => ({
//         //         ...prev, RoomType: parsed
//         //     }))
//         // }
//     }, [])

//     const renderButton = (): JSX.Element => {
//         return (
//             <components.Button
//                 title='See all properties'
//                 style={{
//                     backgroundColor: '#7065F0',
//                     color: '#fff',
//                     border: '1px solid #7065F0',
//                 }}
//                 onClick={() => navigate('/serach-result', { state: { filter } })}
//             />
//         );
//     };

//     const renderContent = (): JSX.Element => {
//         return (
//             <main
//                 className=''
//                 style={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'space-between',
//                     height: '100dvh',
//                     paddingBottom: 25,
//                     overflow: 'hidden'
//                 }}
//             >
//                 <div style={{ overflow: "auto" }}>
//                     {renderTitle()}

//                     {filterHeading({ title: "Recently Selected Localities" })}
//                     {renderRecentLocationsGrid()}
//                     {filterHeading({ title: "Room Type" })}
//                     {renderRecentLocationsGrid2()}

//                     {filterHeading({ title: "Select Price Range (₹)" })}
//                     {renderPriceRangeSelector()}
//                 </div>
//                 <div style={{
//                     paddingRight: 20,
//                     paddingLeft: 20,
//                 }}>
//                     {renderButton()}
//                 </div>
//             </main>
//         );
//     };

//     return (
//         <>
//             {renderHeader()}
//             {renderContent()}
//         </>
//     );
// };

// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// import { text } from '../text';
// import { hooks } from '../hooks';
// import { utils } from '../utils';
// import { svg } from '../assets/svg';
// import { theme } from '../constants';
// import { components } from '../components';
// import { colors } from '../constants/colors';
// import { FilterSvg } from '../assets/svg/FilterSvg';

// const price = [
//     {
//         id: 1,
//         name: 'Paid (142)',
//     },
//     {
//         id: 2,
//         name: 'Free (18)',
//     },
// ];

// export const Onboarding7: React.FC = () => {
//     const location = useLocation();
//     const { pathname } = useLocation();
//     const [priceRange, setPriceRange] = useState<[number, number]>([2000, 8000]);
//     const minLimit = 1000;  // Minimum possible value
//     const maxLimit = 100000; // Maximum possible value
//     const minGap = 500; // Minimum gap between min and max (to avoid overlap)

//     const rangeInputStyle: React.CSSProperties = {
//         position: 'absolute',
//         top: 22,
//         width: '100%',
//         height: '4px',
//         background: 'transparent',
//         pointerEvents: 'auto',
//         zIndex: 4,
//     };

//     useEffect(() => {
//         const scrollToTop = () => {
//             window.scrollTo(0, 0);
//             document.documentElement.scrollTop = 0;
//         };

//         scrollToTop();
//     }, [pathname]);

//     const navigate = hooks.useNavigate();

//     const [selectedPrice, setSelectedPrice] = useState<number | null>(price[0].id);

//     // const [recentLocations, setRecentLocations] = useState<string[]>([
//     //     'Delhi', 'Mumbai', 'Bengaluru', 'Pune', 'Hyderabad', 'Hyderabad','Hyderabad','Hyderabad',
//     // ]);

// const [recentLocations, setRecentLocations] = useState<string[]>([
//   'Connaught Place',
//   'Karol Bagh',
//   'Saket',
//   'Lajpat Nagar',
//   'Dwarka',
//   'Hauz Khas',
//   'Rohini',
//   'Vasant Kunj',
//   'Janakpuri',
//   'Chandni Chowk'
// ]);

//     const handleRemoveCity = (cityToRemove: string) => {
//         setRecentLocations(prev => prev.filter(city => city !== cityToRemove));
//     };

//     const renderHeader = (): JSX.Element => {
//         return (
//             <components.Header
//                 title=''
//                 goBack={true}
//                 skip={true}
//                 clear={false}
//                 clearOnClicked={() => { }}
//             />
//         );
//     };

//     const renderTitle = (): JSX.Element => {
//         return (
//             <div className='container' style={{ marginTop: 30 }}>
//                 <div className='filterHead'>
//                     {/* <div className='filterWithIcon'>
//                         <FilterSvg color='#7065F0' size={20} />

//                     </div> */}
//                     <p className='headingCity ' style={{ textAlign: "left", fontSize: "26px" }}>
//                         Filter
//                     </p>
//                     <p className='filterClear'> Clear all</p>
//                 </div>

//                 <div className='changeCityContainer'>
//                     <p className='paraCity leftText'>
//                         Select Locality in <span className="cityHighlight">Delhi</span>
//                     </p>
//                     <p className='paraCity leftText boldText'>Change City</p>
//                 </div>

//             </div>
//         );
//     };

//     // const renderTitle = (): JSX.Element => {
//     //     return (
//     //         <div className='container' style={{ marginTop: 30 }}>
//     //             <text.H2
//     //                 style={{
//     //                     textTransform: 'capitalize',
//     //                     color: "#7065F0",
//     //                 }}
//     //             >
//     //                 Share your requirement with us
//     //                 {/* You are looking to rent in */}
//     //             </text.H2>
//     //         </div>
//     //     );
//     // };

//     const renderPriceRangeSelector = (): JSX.Element => {
//         const [minVal, maxVal] = priceRange;

//         const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//             const value = Number(e.target.value);
//             if (value < maxVal - minGap) {
//                 setPriceRange([value, maxVal]);
//             }
//         };

//         const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//             const value = Number(e.target.value);
//             if (value > minVal + minGap) {
//                 setPriceRange([minVal, value]);
//             }
//         };

//         const getLeft = () => ((minVal - minLimit) / (maxLimit - minLimit)) * 100;
//         const getWidth = () =>
//             ((maxVal - minVal) / (maxLimit - minLimit)) * 100;

//         return (
//             <div className="container" style={{ marginTop: 20 }}>
//                 <text.T18
//                     style={{
//                         color: colors.secondaryTextColor,
//                         marginBottom: 10,
//                     }}
//                 >
//                     Select Price Range (₹)
//                 </text.T18>

//                 <div style={{ marginBottom: 10, fontSize: 14 }}>
//                     ₹{minVal} - ₹{maxVal}
//                 </div>

//                 {/* Slider Wrapper */}
//                 <div style={{ position: 'relative', height: 40 }}>
//                     {/* Background track */}
//                     <div
//                         style={{
//                             position: 'absolute',
//                             top: '50%',
//                             transform: 'translateY(-50%)',
//                             width: '100%',
//                             height: 4,
//                             backgroundColor: '#ccc',
//                             borderRadius: 2,
//                             zIndex: 1,
//                         }}
//                     />

//                     {/* Active range track */}
//                     <div
//                         style={{
//                             position: 'absolute',
//                             top: '50%',
//                             transform: 'translateY(-50%)',
//                             height: 4,
//                             backgroundColor: '#7065F0',
//                             borderRadius: 2,
//                             left: `${getLeft()}%`,
//                             width: `${getWidth()}%`,
//                             zIndex: 2,
//                         }}
//                     />

//                     {/* Range sliders */}
//                     <input
//                         type="range"
//                         min={minLimit}
//                         max={maxLimit}
//                         value={minVal}
//                         onChange={handleMinChange}
//                         style={rangeInputStyle}
//                     />
//                     <input
//                         type="range"
//                         min={minLimit}
//                         max={maxLimit}
//                         value={maxVal}
//                         onChange={handleMaxChange}
//                         style={rangeInputStyle}
//                     />
//                 </div>

//                 {/* Thumb Styles */}
//                 <style>
//                     {`
//         input[type='range'] {
//           -webkit-appearance: none;
//         }

//         input[type='range']::-webkit-slider-thumb {
//           -webkit-appearance: none;
//           height: 20px;
//           width: 20px;
//           border-radius: 50%;
//           background: white;
//           border: 3px solid #7065F0;
//           margin-top: -8px;
//           cursor: pointer;
//           position: relative;
//           z-index: 3;
//         }

//         input[type='range']::-moz-range-thumb {
//           height: 20px;
//           width: 20px;
//           border-radius: 50%;
//           background: white;
//           border: 3px solid #7065F0;
//           cursor: pointer;
//           position: relative;
//           z-index: 3;
//         }
//       `}
//                 </style>
//             </div>
//         );
//     };

// //     const renderRecentLocationsGrid = (): JSX.Element => {
// //         return (
// //             <div className="container" style={{ marginTop: 20 }}>
// //                 <p>Recently Selected Loalities</p>

// //       <div className='location-container'>
// //   <div className='location-scroll'>
// //     <div className='location-grid'>
// //       {recentLocations.map((city, index) => (
// //         <div key={index} className='location-card' style={{ position: 'relative' }}>
// //           {city}
// //           <button
// //             onClick={() => handleRemoveCity(city)}
// //             style={{
// //               position: 'absolute',
// //               top: 4,
// //               right: 6,
// //               cursor: 'pointer',
// //               fontWeight: 'bold',
// //               fontSize: 12,
// //               color: '#999',
// //               background: 'transparent',
// //               border: 'none',
// //               padding: 0,
// //               lineHeight: 1,
// //             }}
// //             title="Remove"
// //             aria-label={`Remove ${city}`}
// //           >
// //             ×
// //           </button>
// //         </div>
// //       ))}
// //     </div>
// //   </div>
// // </div>

// //                 <style>
// //                     {`
// //           @media (min-width: 768px) {
// //             .recent-locations-grid {
// //               grid-template-columns: repeat(5, 1fr) !important;
// //             }
// //           }

// //           .recent-locations-grid::-webkit-scrollbar {
// //             width: 6px;
// //           }
// //           .recent-locations-grid::-webkit-scrollbar-thumb {
// //             background-color: rgba(0, 0, 0, 0.2);
// //             border-radius: 4px;
// //           }
// //         `}
// //                 </style>
// //             </div>
// //         );
// //     };

//     const renderDescription = (): JSX.Element => {
//         return (
//             <div className='container' style={{ marginTop: 10 }}>
//                 <text.T18
//                     style={{
//                         lineHeight: 1,
//                         whiteSpace: 'pre-line',
//                     }}
//                 >
//                     Filter applied
//                 </text.T18>
//             </div>
//         );
//     };
//     const renderDescription1 = (): JSX.Element => {
//         return (
//             <div className='container' style={{ marginTop: 10 }}>
//                 <text.T18
//                     style={{
//                         lineHeight: 1,
//                         color: colors.secondaryTextColor,
//                         whiteSpace: 'pre-line',
//                     }}
//                 >
//                     Locate my location
//                 </text.T18>
//             </div>
//         );
//     };
//     const locations = [
//         'Girls', 'Boys', 'Others'
//     ];

//     const genderOptions = ['Girls', 'Boys', 'Others'];
//     const propertyTypes = ['PG', 'Flat'];
//     const roomTypes = ['Single Sharing', 'Double Sharing']
//     const furnishTypes = ['Furnished', 'Semi-Furnished', 'Non-Furnished']
//     const renderOptionGrid = (
//         title: string,
//         options: string[],
//         maxHeight: number = 120
//     ): JSX.Element => {
//         return (
//             <div className="container" style={{ marginTop: 20 }}>
//                 <div style={{ maxHeight, overflowY: 'auto' }}>
//                     <text.T18
//                         style={{
//                             lineHeight: 1,
//                             marginBlock: 10,
//                             color: colors.secondaryTextColor,
//                             whiteSpace: 'pre-line',
//                         }}
//                     >
//                         {title}
//                     </text.T18>
//                     <div
//                         style={{
//                             display: 'grid',
//                             gap: 10,
//                             gridTemplateColumns: 'repeat(3, 1fr)',
//                         }}
//                         className="option-grid"
//                     >
//                         {options.map((option, index) => (
//                             <div
//                                 key={index}
//                                 style={{
//                                     padding: '12px',
//                                     border: '1px solid #ccc',
//                                     borderRadius: 5,
//                                     textAlign: 'center',
//                                     fontSize: 14,
//                                     backgroundColor: '#f9f9f9',
//                                 }}
//                             >
//                                 {option}
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 <style>
//                     {`
//                     @media (min-width: 768px) {
//                         .option-grid {
//                             grid-template-columns: repeat(5, 1fr) !important;
//                         }
//                     }

//                     .option-grid::-webkit-scrollbar {
//                         width: 6px;
//                     }
//                     .option-grid::-webkit-scrollbar-thumb {
//                         background-color: rgba(0, 0, 0, 0.2);
//                         border-radius: 4px;
//                     }
//                 `}
//                 </style>
//             </div>
//         );
//     };

//     const renderButton = (): JSX.Element => {
//         return (
//             <components.Button
//                 title='See all properties'
//                 style={{
//                     backgroundColor: '#7065F0',
//                     color: '#fff',
//                     border: '1px solid #7065F0',
//                 }}
//                 onClick={() => navigate('/tab-navigator')}
//             />
//         );
//     };

//     const renderContent = (): JSX.Element => {
//         return (
//             <main
//                 className=''
//                 style={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'space-between',
//                     minHeight: '100vh',
//                     paddingBottom: 20,
//                 }}
//             >
//                 <div>
//                     {renderTitle()}
//                     {renderDescription()}
//                     {renderRecentLocationsGrid()}
//                     {renderDescription1()}
//                     {renderOptionGrid('Property Type', propertyTypes)}
//                     {renderOptionGrid('Boys/Girls*', genderOptions)}
//                     {renderPriceRangeSelector()}
//                     {renderOptionGrid('Room Types', roomTypes)}
//                     {renderOptionGrid('Furnishing Types', furnishTypes)}
//                 </div>
//                 <div style={{
//                     paddingRight: 20,
//                     paddingLeft: 20,
//                 }}>
//                     {renderButton()}
//                 </div>
//             </main>
//         );
//     };

//     return (
//         <>
//             {renderHeader()}
//             {renderContent()}
//         </>
//     );
// };
